import * as uuid from 'uuid';

import {FlowchartMetadata} from 'processes/graph-builder/flowchart-viz/FlowchartVizConstants';
import {ProcessTaskSchemaForGraphBuilderValidation} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

import {ProcessFlowchartV2GraphQL} from '../../../../../graphql-fragments/processes/__generated/ProcessFlowchartV2GraphQL';
import {
  ProcessFlowchartStaticNodeAnalyticsData,
  ProcessStaticFlowchart,
} from '../ProcessFlowchartVizConstants';
import {convertFlowchartV2GqlToProcessStaticFlowchart} from './convertFlowchartV2GqlToProcessFlowchart';

interface BuildStaticFlowchartStructureFromGqlParams {
  flowchartStructure: ProcessFlowchartV2GraphQL | null;
  schema: ProcessTaskSchemaForGraphBuilderValidation;
  nodeAnalytics?: ProcessFlowchartStaticNodeAnalyticsData;
  metadata?: FlowchartMetadata;
}

export default function buildStaticFlowchartStructureFromGql({
  flowchartStructure,
  schema,
  nodeAnalytics,
  metadata,
}: BuildStaticFlowchartStructureFromGqlParams): ProcessStaticFlowchart {
  const flowchartClientId = uuid.v4();
  if (flowchartStructure == null) {
    return {clientId: flowchartClientId, nodes: [], edges: []};
  }

  const flowchart = convertFlowchartV2GqlToProcessStaticFlowchart(flowchartStructure);

  const {nodes, edges} = flowchart;
  nodes.forEach((node) => {
    node.analyticsData = {
      ...(node.analyticsData != null ? node.analyticsData : {}),
      ...(nodeAnalytics != null ? nodeAnalytics : {}),
    };
  });
  return {
    clientId: flowchartClientId,
    nodes,
    edges,
    metadata,
  };
}
